import React from "react";
import { useNavigate } from "react-router-dom";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { useLocation } from "react-router-dom";

function SideBarDropdown({ label, url, dropdownList, icon }) {
   const navigate = useNavigate();
   const location = useLocation();

   const isParentActive = location.pathname.startsWith(url);
   const [open, setOpen] = React.useState(isParentActive);
   const handleClick = () => {
      setOpen(!open);
   };

   const [openSubmenu, setOpenSubmenu] = React.useState("");
   const handleOpenSubmenu = (submenuName) => {
      setOpenSubmenu((prev) => (prev === submenuName ? "" : submenuName));
   };

   return (
      <>
         <ListItemButton
            className={`nav-item menu-open wis-side-item ${open ? "is-open" : ""}`}
            onClick={handleClick}
         >
            <ListItemIcon className="text-white" sx={{ minWidth: 30 }}>
               <i className={`nav-icon fas ${icon}`} />
            </ListItemIcon>
            <ListItemText primary={label} className="text-white nav-item" />
            <ListItemIcon className="text-white" sx={{ minWidth: 26, ml: 1 }}>
               <i className={`fas ${open ? "fa-angle-down" : "fa-angle-left"} right`} />
            </ListItemIcon>
         </ListItemButton>

         <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="wis-side-submenu">
               {dropdownList.map((item, index) => {
                  const hasSubmenu = item.subDropdownList.length > 0;
                  const isItemActive =
                     location.pathname === `${url + item.url}` ||
                     location.pathname.startsWith(`${url + item.url}/`);
                  return (
                     <React.Fragment key={index.toString()}>
                        <ListItemButton
                           className={`nav-item text-white wis-side-subitem ${
                              isItemActive ? "active" : ""
                           }`}
                           onClick={() => {
                              navigate(
                                 hasSubmenu
                                    ? "#"
                                    : `${url + item.url}`
                              );
                              handleOpenSubmenu(item.subMenuName);
                           }}
                           sx={{ pl: 3.2 }}
                        >
                           <ListItemText
                              primary={item.subMenuName}
                              className="text-white wis-side-subtext"
                           />
                           {hasSubmenu && (
                              <ListItemIcon
                                 className="text-white"
                                 sx={{ minWidth: 26, ml: 1 }}
                              >
                                 <i
                                    className={`right fas ${
                                       openSubmenu === item.subMenuName
                                          ? "fa-angle-down"
                                          : "fa-angle-left"
                                    }`}
                                 ></i>
                              </ListItemIcon>
                           )}
                        </ListItemButton>

                        <Collapse
                           in={openSubmenu === item.subMenuName}
                           timeout="auto"
                           unmountOnExit
                        >
                           <List component="div" disablePadding>
                              {item.subDropdownList.map((itemSub, index) => {
                                 const isSubItemActive =
                                    location.pathname === url + item.url + itemSub.url;
                                 return (
                                    <ListItemButton
                                       key={`${index}`}
                                       className={`wis-side-subchild ${
                                          isSubItemActive ? "active" : ""
                                       }`}
                                       sx={{ pl: 7 }}
                                       onClick={() => {
                                          navigate(url + item.url + itemSub.url);
                                       }}
                                    >
                                       <ListItemIcon
                                          className="text-white"
                                          sx={{ minWidth: 28 }}
                                       >
                                          <i className="far fa-dot-circle nav-icon"></i>
                                       </ListItemIcon>
                                       <ListItemText
                                          primary={itemSub.subMenuName}
                                          className="text-white"
                                       />
                                    </ListItemButton>
                                 );
                              })}
                           </List>
                        </Collapse>
                     </React.Fragment>
                  );
               })}
            </List>
         </Collapse>
      </>
   );
}

export default SideBarDropdown;
